/** Inline-SVG ornaments for the unit frames: role icons and the portrait ring contents. */
import type { NpcTier, Role } from '@keystone/sim';
import { crestSvg, glyphSvg, svgEl } from '../kit';

/** Role glyph bodies (24×24, currentColor). */
const ROLE_GLYPH: Readonly<Record<Role, string>> = {
  tank: '<path fill="currentColor" fill-opacity=".28" d="M12 2.8l7.4 2.7v5.8c0 4.8-3.1 8.2-7.4 10.2-4.3-2-7.4-5.4-7.4-10.2V5.5z"/><path d="M12 6v12"/>',
  healer: '<path fill="currentColor" fill-opacity=".28" d="M9.3 3.5h5.4v5.8h5.8v5.4h-5.8v5.8H9.3v-5.8H3.5V9.3h5.8z"/>',
  dps: '<path d="M5 19 18.5 5.5M18.5 5.5V9.5M18.5 5.5h-4"/><path fill="currentColor" fill-opacity=".28" d="M5 19l-1-1 2.8-.6 1 1z"/><path d="M7.2 14.2l2.6 2.6"/>',
};

/** A role icon (<svg class="fp-role-svg role-*">). */
export function roleSvg(role: Role | null): SVGSVGElement {
  const r = role ?? 'dps';
  return svgEl(
    `<svg class="fr-role-svg role-${r}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">${ROLE_GLYPH[r]}</svg>`,
  );
}

/** Portrait contents: the class crest for players, a tier glyph inside a dark disc for enemies. */
export function portraitSvg(classId: string | null, tier: NpcTier | null): SVGSVGElement {
  if (classId) return crestSvg(classId);
  return glyphSvg(tier === 'boss' || tier === 'miniboss' ? 'skull' : 'swords', 'fr-portrait-glyph');
}
